var Acr = Acr || {};

declare global {
    interface Window {
        Utility: any;
    }
}

var Utility = window.Utility || {};

import * as SwiperJS from '../../../js/vendor/swiper.min.js';
import Swiper, { SelectableElement, SwiperOptions } from 'swiper';


export function AcrPackageDetail() {

    let spinnerOverlay: HTMLElement;
    let packageDetail: HTMLElement;
    let colorButton: NodeListOf<HTMLElement>;
    let colorNameLabels: NodeListOf<HTMLElement>;;
    let buildUrl: HTMLElement;
    let availableBuild: HTMLElement;
    let arrowRight: SelectableElement;
    let arrowLeft: SelectableElement;
    let swiperPagination: SelectableElement;
    let imgUrl: HTMLElement;
    let packageDetailSwiper: Swiper;
    let packageDetailSwiperContainer: HTMLElement;
    let avoidingClicking: HTMLElement;
    const regexColorToken = /\[%colorCode%]/g;
    const regexInteriorToken = /\[%interiorCode%]/g;
    const regexModelToken = /\[%modelId%]/g;
    const spinnerOverlaySelector = '.js-spinner-overlay';
    const colorButtonSelector = '.js-color-button';
    const isActive = 'is-active';
    const colorNameLabel = '.js-color-name-label';
    const buildUrlSelector = '.js-build-link';
    const availableBuildSelector = '.js-available-build';
    const imgUrlSelector = '.js-img-src';
    const lazyPackagesClass = '.js-lazy-packages';
    const swiperContainerClass = '.js-swiper-container';
    const swiperPaginationClass = '.js-swiper-pagination';
    const arrowLeftClass = '.js-arrow-left';
    const arrowRightClass = '.js-arrow-right';
    const avoidingClickingClass = '.js-avoid-clicking';

    const initSwiper = ():void => {
        const packageDetailSwiperOptions: SwiperOptions = {
            speed: 400,
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: swiperPagination,
                clickable: true,
                bulletClass: 'acr-package-detail__bullet',
                bulletActiveClass: 'acr-package-detail__bullet-active',
            },
            navigation: {
                nextEl: arrowRight,
                prevEl: arrowLeft,
            },
        }

        packageDetailSwiper = new SwiperJS(packageDetailSwiperContainer, packageDetailSwiperOptions);

        packageDetailSwiper.on('slideChangeTransitionStart', function () { setDefaultData(); });
        packageDetailSwiper.on('slideChange', function () {
            if (Acr.TrackingManager) {
                Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
            }
        });


        window.addEventListener('swiperUpdate', function (event) {
            updateSwiper();
        });
    };

    const updateSwiper = () => {
        packageDetailSwiper.update();
    };

    const setColorData = (selectedColor: HTMLElement):void => {
        let colorId: string = selectedColor.dataset.id;
        let colorCode: string = selectedColor.dataset.colorCode;
        let interiorCode: string = selectedColor.dataset.interiorCode;
        let modelList: string[] = selectedColor.dataset.modelids.split(',');

        // Update the color label text
        colorNameLabels.forEach(el => {
            let label: HTMLElement = el;
            let labelId: string = label.dataset.id;
            if (labelId === colorId) {
                label.classList.add(isActive);
            } else {
                label.classList.remove(isActive);
            }
        });

        updateBuildUrl(colorCode, interiorCode);
        updateImgUrl(colorCode, modelList[0]);
        displayAvailableBuild(modelList);
    };

    const updateBuildUrl = (colorCode: string, interiorCode: string):void => {
        if (buildUrl) {
            let newUrl = buildUrl.dataset.href.replace(regexColorToken, colorCode);
            newUrl = newUrl.replace(regexInteriorToken, interiorCode);
            buildUrl.setAttribute('href', newUrl);
        }
    };

    const updateImgUrl = (colorCode, modelId):void => {
        let currentIndex;
        let newUrl: string;
        let newImage: HTMLImageElement;

        currentIndex = packageDetailSwiper.realIndex || 0;

        imgUrl = packageDetail.querySelector('img.swiper-slide-active');

        if (!imgUrl) {
            imgUrl = packageDetail.querySelector('img.swiper-slide-duplicate-active');
        }

        if (imgUrl && !imgUrl.classList.contains('loaded')) {
            avoidingClicking.classList.add('avoid-clicking');
            newImage = new Image();
            spinnerOverlay.style.display = 'block';
            newUrl = imgUrl.dataset.src.replace(regexColorToken, colorCode);
            newUrl = newUrl.replace(regexModelToken, modelId);
            newImage.src = newUrl;
            newImage.onload = function () {

                imgUrl.setAttribute('src', newUrl);
                imgUrl.classList.add('loaded');
                spinnerOverlay.style.display = 'none';
                avoidingClicking.classList.remove('avoid-clicking');
            };
        }
    };

    const displayAvailableBuild = (modelList):void => {
        if (availableBuild) {
            if (modelList.indexOf(availableBuild.dataset.modelId) !== -1) {
                availableBuild.style.display = 'block';
            } else {
                availableBuild.style.display = 'none';
            }
        }
    };

    const setDefaultData = ():void => {
        let selectedColor;

        colorButton.forEach(el => {
            if (el.classList.contains('is-active')) {
                selectedColor = el;
            }
        });

        if (selectedColor) {
            setColorData(selectedColor);
        }
    };

    const initImages = ():void => {
        setDefaultData();
    }

    const resetImages = ():void => {
        let carouselImg = packageDetail.querySelectorAll('.js-img-src');
        carouselImg.forEach( el => {
            el.setAttribute('src', '');
            el.classList.remove('loaded');
        });
    }

    const initLazyLoading = ():void => {
        let lazyElement = [].slice.call(document.querySelectorAll(lazyPackagesClass));
        Utility.initLazyLoadingIO(lazyElement, initImages);
    }

    const changeColor = (ele: HTMLElement):void => {
        event.preventDefault();
        colorButton.forEach(el => {
            el.classList.remove(isActive);
        });
        ele.classList.add(isActive);
        resetImages();
        setColorData(ele);
    };

    const initSelectors = (element: HTMLElement):void => {
        packageDetail = element;
        spinnerOverlay = packageDetail.querySelector(spinnerOverlaySelector);
        colorButton = packageDetail.querySelectorAll(colorButtonSelector);
        colorNameLabels = packageDetail.querySelectorAll(colorNameLabel);
        buildUrl = packageDetail.querySelector(buildUrlSelector);
        imgUrl = packageDetail.querySelector(imgUrlSelector);
        availableBuild = packageDetail.querySelector(availableBuildSelector);
        arrowRight = packageDetail.querySelector(arrowRightClass) as HTMLElement;
        arrowLeft = packageDetail.querySelector(arrowLeftClass) as HTMLElement;
        swiperPagination = packageDetail.querySelector(swiperPaginationClass) as HTMLElement;
        packageDetailSwiperContainer = packageDetail.querySelector(swiperContainerClass);
        avoidingClicking = packageDetail.querySelector(avoidingClickingClass);
    };

    const bindEvents = ():void => {
        colorButton.forEach(el => {
            el.addEventListener("click", () => {
                changeColor(el);
            });
        });
    };

    const init = (element: HTMLElement):void => {
        initSelectors(element);
        initSwiper();
        bindEvents();
        initLazyLoading();
    };

    return { init };

}
